<template>
  <div class="dialog_container">
    <el-dialog
      title="车辆详情"
      :visible="dialogShow"
      width="1288px"
      @close="dialogClose"
      top="10vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <div class="form_title">基本信息</div>
        <ul class="info_box">
          <li>
            <div class="li_title">车牌号码：</div>
            <div class="li_text">{{ carDetail.carNumber }}</div>
          </li>
          <li>
            <div class="li_title">车牌颜色：</div>
            <div class="li_text">{{ carDetail.carColorStr }}</div>
          </li>
          <li>
            <div class="li_title">车辆类型：</div>
            <div class="li_text">{{ carDetail.carTypeStr }}</div>
          </li>
          <li>
            <div class="li_title">车辆营运性质：</div>
            <div class="li_text">
              {{
                carDetail.carService == 1
                  ? "乘用车"
                  : carDetail.carService == 2
                  ? "客车"
                  : carDetail.carService == 3
                  ? "普货"
                  : carDetail.carService == 4
                  ? "危货"
                  : carDetail.carService == 5
                  ? "出租车"
                  : carDetail.carService == 6
                  ? "教练车"
                  : carDetail.carService == 7
                  ? "公交车"
                  : ""
              }}
            </div>
          </li>
          <li>
            <div class="li_title">车架号VIN：</div>
            <div class="li_text">{{ carDetail.vin }}</div>
          </li>
          <li>
            <div class="li_title">燃油类型：</div>
            <div class="li_text">{{
                carDetail.fuelType  == 1
                  ? "柴油"
                  : carDetail.fuelType  == 2
                  ? "汽油"
                  : carDetail.fuelType  == 3
                  ? "天然油"
                  : carDetail.fuelType  == 4
                  ? "电动"
                  : carDetail.fuelType  == 5
                  ? "双燃料"
                  : carDetail.fuelType  == 6
                  ? "气电混合动力"
                  : carDetail.fuelType  == 7
                  ? "其他"
                  : ""
              }}</div>
          </li>
          <li>
            <div class="li_title">车辆厂牌：</div>
            <div class="li_text">{{ carDetail.carFactory }}</div>
          </li>
          <li>
            <div class="li_title">车辆型号：</div>
            <div class="li_text">{{ carDetail.carModel }}</div>
          </li>
          <li>
            <div class="li_title">轴距：</div>
            <div class="li_text">{{ carDetail.wheelbase }}</div>
          </li>
          <li class="li_3">
            <div>
              <div>长：</div>
              <div>{{ carDetail.carSpecsLong || 0 }} mm</div>
            </div>
            <div>X</div>
            <div>
              <div>宽：</div>
              <div>{{ carDetail.carSpecsWidth || 0 }} mm</div>
            </div>
            <div>X</div>
            <div>
              <div>高：</div>
              <div>{{ carDetail.carSpecsHigh || 0 }} mm</div>
            </div>
          </li>
          <li>
            <div class="li_title">发动机号：</div>
            <div class="li_text">{{ carDetail.engineSn }}</div>
          </li>
          <li>
            <div class="li_title">核定座位数：</div>
            <div class="li_text">{{ carDetail.approvedPerson || 0 }}</div>
          </li>
          <li>
            <div class="li_title">车轴数：</div>
            <div class="li_text">{{ carDetail.axleNum || 0 }}</div>
          </li>
          <li>
            <div class="li_title">满载总质量：</div>
            <div class="li_text">{{ carDetail.fullyLaden || 0 }} kg</div>
          </li>
          <li>
            <div class="li_title">准牵引总质量：</div>
            <div class="li_text">{{carDetail.tractionMass || 0}} kg</div>
          </li>
          <li>
            <div class="li_title">核定载质量：</div>
            <div class="li_text">{{carDetail.approvedLaden || 0}} kg</div>
          </li>
          <li>
            <div class="li_title">整备质量：</div>
            <div class="li_text">{{carDetail.curbWeight || 0}} kg</div>
          </li>
          <li>
            <div class="li_title">所属企业：</div>
            <div class="li_text">{{carDetail.companyName}}</div>
          </li>
          <li>
            <div class="li_title">行驶证初领日期：</div>
            <div class="li_text">{{carDetail.driverTime}}</div>
          </li>
          <li>
            <div class="li_title">行驶证有效期：</div>
            <div class="li_text">{{carDetail.roadEndTime}}</div>
          </li>
          <li>
            <div class="li_title">车辆登记证号：</div>
            <div class="li_text">{{carDetail.carRegisterNumber}}</div>
          </li>
          <li>
            <div class="li_title">车辆状态：</div>
            <div class="li_text">{{carDetail.carState == 1 ? '有效':'无效'}}</div>
          </li>
          <li>
            <div class="li_title">发动机型号：</div>
            <div class="li_text">{{carDetail.engineModel}}</div>
          </li>
          <li>
            <div class="li_title">发动机功率：</div>
            <div class="li_text">{{carDetail.enginePower || 0}} kw</div>
          </li>
          <li>
            <div class="li_title">登记证发证日期：</div>
            <div class="li_text">{{carDetail.registerTime}}</div>
          </li>
        </ul>

        <div class="form_title">车辆道路运输证信息</div>
        <ul class="info_box">
          <li>
            <div class="li_title">道路运输证：</div>
            <div class="li_text">{{carDetail.roadTransportNumber}}</div>
          </li>
          <li>
            <div class="li_title">发证机构：</div>
            <div class="li_text">{{carDetail.roadOrgIdStr}}</div>
          </li>
          <li>
            <div class="li_title">证件状态：</div>
            <div class="li_text">{{carDetail.roadState == 1 ? '有效':'无效'}}</div>
          </li>
          <li>
            <div class="li_title">初领日期：</div>
            <div class="li_text">{{carDetail.roadTime}}</div>
          </li>
          <li style="width: 800px">
            <div class="li_title">有效期：</div>
            <div class="li_text">{{carDetail.roadEndTime}}</div>
          </li>
        </ul>

        <div class="form_title">挂车信息</div>
        <ul class="info_box">
          <li>
            <div class="li_title">挂车车牌：</div>
            <div class="li_text">{{carDetail.trailerCarNumber}}</div>
          </li>
          <li>
            <div class="li_title">车辆营运性质：</div>
            <div class="li_text">{{
                carDetail.trailerCarService == 1
                  ? "乘用车"
                  : carDetail.trailerCarService == 2
                  ? "客车"
                  : carDetail.trailerCarService == 3
                  ? "普货"
                  : carDetail.trailerCarService == 4
                  ? "危货"
                  : carDetail.trailerCarService == 5
                  ? "出租车"
                  : carDetail.trailerCarService == 6
                  ? "教练车"
                  : carDetail.trailerCarService == 7
                  ? "公交车"
                  : ""
              }}</div>
          </li>
          <li>
            <div class="li_title">车辆厂牌：</div>
            <div class="li_text">{{carDetail.trailerLabel}}</div>
          </li>
          <li>
            <div class="li_title">车架号VIN：</div>
            <div class="li_text">{{carDetail.trailerVin}}</div>
          </li>
          <li>
            <div class="li_title">核定载质量：</div>
            <div class="li_text">{{carDetail.trailerApprovedLaden}}</div>
          </li>
          <li>
            <div class="li_title">道路许可证：</div>
            <div class="li_text">{{carDetail.trailerLicense}}</div>
          </li>
        </ul>

        <div class="form_title">从业人员信息</div>
        <ul class="info_box">
          <li>
            <div class="li_title">姓名：</div>
            <div class="li_text">{{carDetail.driverName1}}</div>
          </li>
          <li>
            <div class="li_title">岗位类别：</div>
            <div class="li_text">{{carDetail.postName1}}</div>
          </li>
          <li>
            <div class="li_title">手机号码：</div>
            <div class="li_text">{{carDetail.driverPhone1}}</div>
          </li>
          <li>
            <div class="li_title">姓名：</div>
            <div class="li_text">{{carDetail.driverName2}}</div>
          </li>
          <li>
            <div class="li_title">岗位类别：</div>
            <div class="li_text">{{carDetail.postName2}}</div>
          </li>
          <li>
            <div class="li_title">手机号码：</div>
            <div class="li_text">{{carDetail.driverPhone2}}</div>
          </li>
        </ul>

        <div class="form_title">其他</div>
        <ul class="info_box">
          <li style="width: 100%">
            <div class="li_title">备注：</div>
            <div class="li_text">{{carDetail.remark}}</div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn btn_ok" @click="confirm">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      carDetail: {},
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default: {},
    },
  },
  watch: {
    dialogShow(val) {
      if (val) {
        this.$http.getCarDetail({ id: this.dialogData.carId }).then((res) => {
          if (res.code == 0) {
            this.carDetail = res.data;
          } else {
            this.carDetail = {};
            this.$message.error(res.msg);
          }
        });
      }
    },
  },
  created() {},
  methods: {
    confirm() {
      this.carDetail = {}
      this.$emit("update:dialogShow", false);
    },
    dialogClose() {
      this.carDetail = {}
      this.$emit("update:dialogShow", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
.uploading_box {
  display: flex;
  flex-wrap: wrap;
  .certificate {
    width: 360px;
    height: 240px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    margin-bottom: 35px;
  }
}
/deep/.el-dialog__body{
    max-height: 70vh;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carInfo_component/detail.vue